module.exports = __webpack_public_path__ + "static/img/AI人脸识别系统.7d0b971.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/AI人脸识别系统.png
// module id = cBwV
// module chunks = 45